module.exports = __webpack_public_path__ + "img/logo-bold-dark-beta.352ef475.png";